import React, { Component } from "react";
import axios from '../../axios';
import qs from "qs";
import { connect } from 'react-redux'
import Alert from 'react-s-alert'
import ModalHelp from "../../components/ModalHelp";


const initialState = {

    isButtonLoading     : false,
    isLoading           : false,

}

class Help extends Component {
    constructor(props) {
        super(props)
        this.state = initialState
        this.state = {
            tutorial: '',
            isModalHelpShow  : false
        };
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
    }

    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/vQid_SDPuOc'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }



    render() {
        console.log(this.state.detailPengumuman)
        return (
            <div className="col-sm-12">
                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />
                <div className="card">
                    <div className="card-header">
                        Bantuan & Saran
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-12">
                                <span>Pusat Bantuan </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Help;


// WEBPACK FOOTER //
// ./src/views/Help/index.js